export const isSitesEnabled = () => {
  const SitesEnabled = process.env.REACT_APP_SITE_MODULE === 'true';
  console.log(SitesEnabled)
  return SitesEnabled;
};

export const isAssetsEnabled = () => {
  const AssetsEnabled = process.env.REACT_APP_ASSET_MODULE === 'true';

  return AssetsEnabled;
};
